import { render } from "./country-list.vue?vue&type=template&id=60b4fef4"
import script from "./country-list.vue?vue&type=script&lang=js"
export * from "./country-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__